import type { PersistenceAwareStorage, ProgressRepo } from '@dcs/platform/ports';
import { sweepProgressStash } from '@dcs/platform/progress';
import { createLocalProgressRepo, createWebStorage } from '@dcs/platform/web';
import { createSwitchableProgressRepo } from './switchable-repo';
import type { SwitchableProgressRepo } from './switchable-repo';

/** The app's progress storage and repo, one per page. */
export interface AppProgress {
  storage: PersistenceAwareStorage;
  /** Browser-local repo (what a guest uses; also the source of truth under the syncing one). */
  local: ProgressRepo;
  /** What screens use: `local` until `useProgressSync` swaps in the syncing repo. */
  repo: SwitchableProgressRepo;
}

let shared: AppProgress | null = null;

/** The shared instance, built on first use so importing this module has no side effect. */
export function getAppProgress(): AppProgress {
  if (shared === null) {
    const storage = createWebStorage();
    // Opportunistic: a session-expiry stash older than 7 days is deleted when the app starts.
    sweepProgressStash(storage, Date.now());
    const local = createLocalProgressRepo(storage);
    shared = { storage, local, repo: createSwitchableProgressRepo(local) };
  }
  return shared;
}

/** Tests only: forget the shared instance. */
export function resetAppProgressForTests(): void {
  shared = null;
}
